import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../Context/authContext';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};
const leadService = {
  _url: `${process.env.REACT_APP_LEAD_API_URL}/agent`,

  GetAgent(searchQuery, id, refetch) {
    const [allTask, setAllTask] = useState({
      task: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      const fetchAgentDetail = async () => {
        try {
          let res = await cancellablePromise(leadService.getAgentDetail(searchQuery, id));
          setAllTask(res);
          setStatus(STATUS.SUCCESS);
        } catch (error) {
          setStatus(STATUS.ERROR);
        }
      };

      fetchAgentDetail();
    }, [
      searchQuery?.page,
      searchQuery?.pageSize,
      searchQuery?.searchText,
      searchQuery?.startDate,
      searchQuery?.endDate,
      searchQuery?.filterStatus,
      refetch,
      id,
    ]);
    return {
      agent_loading: status === STATUS.LOADING,
      agent_error: status === STATUS.ERROR ? status : '',
      agent_data: allTask,
    };
  },

  GetAgentTasks(searchQuery, fetch) {
    const [agentTask, setAgentTask] = useState({
      agentTask: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAgentTasks(searchQuery))
        .then(res => {
          setAgentTask(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);

    return {
      agentTask_loading: status === STATUS.LOADING,
      agentTask_error: status === STATUS.ERROR,
      agentTask_data: agentTask,
    };
  },

  GetLeadsGraph(searchQuery, fetch) {
    const [graph, setGraph] = useState({
      graph: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getLeadsGraph(searchQuery))
        .then(res => {
          setGraph(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);

    return {
      agraph_loading: status === STATUS.LOADING,
      graph_error: status === STATUS.ERROR,
      graph_data: graph,
    };
  },

  async getAllAgents() {
    let res = await Fetch.get(`${this._url}/get-all-agents`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getAgentDetail(
    { page = 1, pageSize = 10, searchText = '', startDate = '', endDate = '', filterStatus = '', agent_type = '' } = {},
    id,
  ) {
    let res = await Fetch.get(
      `${this._url}/get-all-tasks?page=${page}&itemsPerPage=${pageSize}&searchText=${searchText}&startDate=${startDate}&endDate=${endDate}&status=${filterStatus}&agentId=${id}&agent_type=${agent_type}`,
    );
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getSignleAgentDetail(id) {
    let res = await Fetch.get(`${this._url}/get-single-agent/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getAgentTasks({ agentId = '' }) {
    let res = await Fetch.get(`${this._url}/get-agent-analytics?agentId=${agentId}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getLeadsGraph({ agentId = '' }) {
    let res = await Fetch.get(`${this._url}/get-leads-graph?agentId=${agentId}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async deleteTask(id) {
    let res = await Fetch.delete(`${this._url}/delete-task/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};
export default leadService;
